'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var Promise = require('es6-promise').Promise;

exports.default = {
    configData: null,
    hasLoad: function hasLoad(value) {
        return typeof window[value] !== 'undefined';
    },
    loadJs: function loadJs(url) {
        return new Promise(function (resolve) {
            var sc = document.createElement('script');
            sc.src = url;
            sc.onload = function () {
                resolve();
            };
            var s = document.getElementsByTagName('script')[0];
            s.parentNode.insertBefore(sc, s);
        });
    }
};


//////////////////
// WEBPACK FOOTER
// ./~/@souche-vue/vue-position/dist/utils.js
// module id = 193
// module chunks = 4